import { set, cloneDeep } from "lodash";
import { isNonEmptyObject, isNonEmptyString } from '@cayuse/shared-react.utils.type-checks';

import store from "store/store";

import { dateReadFormatter, formatDatesInObject } from "./date";


export const updateEntityAdminTeamMembers = (idAdminTeamMemberArray, source) => {
	if (!isNonEmptyObject(source)) {
		return;
	}

	const updateData = idAdminTeamMemberArray.filter(entry => source.id === entry.id);
	if (updateData.length === 0) {
		return source;
	}

	return updateEntityOrProperty(source)(updateData[0].adminTeamMembers, "adminTeamMembers");
};

export const prepareSingleEntityValues = response => {
	const hasColumnValues = isNonEmptyObject(response.columnValues);

	if (!hasColumnValues) {
		return {};
	}

	const formattedMappedColumnValues = formatDatesInObject(response.columnValues, dateReadFormatter);
	formattedMappedColumnValues.adminTeamMemberData = response.adminTeamMembers;

	return formattedMappedColumnValues;
};

export const updateEntityOrProperty = (entity) => (value, property = '') => {
	let newEntity = cloneDeep(entity);

	if (isNonEmptyString(property)) {
		set(newEntity, property, value);
	} else {
		newEntity = cloneDeep(value);
	}

	return newEntity;
};
